import { makeStyles } from 'tss-react/mui';

// Colors
import { colors } from '../../../../styles/palette';

export const useStyles = makeStyles()((theme, { isKiteUser } = {}) => ({
  accent: { color: colors.gilead.primary1 },
  responseInfo: {
    color: theme.palette.darkGrey,
    fontSize: 14,
    marginTop: theme.spacing(0.5),
    wordBreak: 'break-word',
    [theme.breakpoints.down('md')]: {
      fontSize: 12,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        fontSize: 12,
      }),
    },
  },
  textArea: {
    border: '1px solid #C6CAC6',
    borderRadius: 10,
    fontFamily: isKiteUser
      ? 'Helvetica, sans-serif'
      : 'Proxima Nova, sans-serif',
    fontSize: 16,
    padding: theme.spacing(1),
    width: '100% !important',
    outline: 0,
    resize: 'none',
    '&::placeholder': {
      color: '#C6CAC6',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        fontSize: 14,
      }),
    },
  },
  error: {
    color: colors.gilead.primary1,
    fontSize: 14,
  },
}));
